// extracted by mini-css-extract-plugin
module.exports = {"pageFooter":"_footer_pageFooter__jjnSJ","footerBox":"_footer_footerBox__euv8L"};